import { useMutation } from '@tanstack/react-query';
import { userTypesType } from 'src/features/auth/components/RegisterNewForm/RegisterNewForm';
import { setAuthToken } from 'src/features/auth/utils/auth';
import {
  login,
  putBankTransferData,
  putPaymentConfig,
  putPaymentMethods,
  register,
  updateUser,
} from 'src/services/apiService';

interface PaymentConfigBody {
  before_payment_amount: number;
  before_payment_type: 'fixed' | 'percent';
  enable_before_payment: boolean;
}
interface PaymentBankTransferDataBody {
  data: string;
}
interface PaymentMethodsBody {
  payment_methods: number[];
}

// LOGIN
export const useLoginMutation = () =>
  useMutation<any, any>({
    mutationFn: async (values: any) => {
      const { email, password } = values;
      const res = await login({ email, password, clinicId: '' });
      const token = res.data?.data.token;
      setAuthToken(token);
      return res;
    },
  });

// REGISTER
export const useRegisterMutation = (userType: userTypesType) =>
  useMutation({
    mutationFn: async (values: any) => {
      values.user_type = userType;
      return await register(values);
    },
  });

// UPDATE USER
export const useUpdateUserMutation = () =>
  useMutation({
    mutationFn: async (values: any) => await updateUser(values),
  });

// UPDATE PAYMENT CONFIG
export const usePaymentConfigMutation = () =>
  useMutation({
    mutationFn: async (values: PaymentConfigBody) =>
      await putPaymentConfig(values),
  });

//UPDATE BANK TRANSFER DATA
export const usePaymentBankTransferDataMutation = () =>
  useMutation({
    mutationFn: async (values: PaymentBankTransferDataBody) =>
      await putBankTransferData(values),
  });

// UPDATE PAYMENT METHODS
export const usePaymentMethodsMutation = () =>
  useMutation({
    mutationFn: async (values: PaymentMethodsBody) =>
      await putPaymentMethods(values),
  });
